import React from "react"

const CellDivider = () => {
  return <div className='w-px h-full bg-[#131B1F] absolute right-0 top-0'></div>
}

export default CellDivider
